import i18n from "../i18n";
import Root from "../Root";
import HomePage from "../pages/HomePage";
import LoginModal from "../modals/LoginModal";
import CoursesPage from "../pages/CoursesPage";
import RegisterModal from "../modals/RegisterModal";
import ProfileEditPage from "../pages/ProfileEditPage";
import CourseDetailModal from "../modals/CourseDetailModal";
import {modalBeforeEnterFactory} from '../helpers/tools';
import PasswordResetModal from "../modals/PasswordResetModal";
import PasswordResetResponseModal from "../modals/PasswordResetResponseModal";
import PasswordResetPage from "../pages/PasswordResetPage";

export default [
  {
    path: "/",
    redirect: i18n.locale,
  },
  {
    path: "/:locale",
    component: Root,
    children: [
      {
        path: "",
    name: 'HomePage',
    component: HomePage,
    meta: { hideFromAuth: true }
  },
  {
    path: 'help',
    name: 'HelpPage',
    component: () => import(/* webpackChunkName: "help_page" */ '../pages/HelpPage'),
  },
  {
    path: 'about',
    name: 'AboutPage',
    component: () => import(/* webpackChunkName: "about_page" */ '../pages/AboutPage'),
  },
  {
    path: 'courses',
    name: 'CoursesPage',
    component: CoursesPage,
    meta: { requiresAuth: true },
  },
  {
    path: 'courses/:id/details',
    name: 'CourseDetailModal',
    components: {
      modal: CourseDetailModal,
    },
    beforeEnter: modalBeforeEnterFactory(HomePage)
  },
  {
    path: 'courses/:id',
    name: 'CoursePage',
    component: () => import(/* webpackChunkName: "course_page" */ '../pages/CoursePage'),
    meta: { requiresAuth: true },
  },
  {
    path: 'profile',
    name: 'ProfilePage',
    component: () => import(/* webpackChunkName: "profile_page" */ '../pages/ProfilePage'),
    meta: { requiresAuth: true },
  },
  {
    path: 'profile/edit',
    component: ProfileEditPage,
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: 'ProfileEditPage',
        component: () => import(/* webpackChunkName: "profile_edit_form" */ '../components/ProfileEditForm'),
      },
      {
        path: "password",
        name: 'PasswordEditPage',
        component: () => import(/* webpackChunkName: "password_edit_form" */ '../components/PasswordEditForm'),
      },
    ]
  },
  {
    path: 'login',
    name: 'LoginModal',
    components: { modal: LoginModal },
    beforeEnter: modalBeforeEnterFactory(HomePage)
  },
  {
    path: 'register',
    name: 'RegisterModal',
    components: { modal: RegisterModal },
    beforeEnter: modalBeforeEnterFactory(HomePage)
  },
  {
    path: 'reset',
    name: 'PasswordResetModal',
    components: { modal: PasswordResetModal },
    beforeEnter: modalBeforeEnterFactory(HomePage)
  },
  {
    path: 'reset/response',
    name: 'PasswordResetResponseModal',
    components: { modal: PasswordResetResponseModal },
    beforeEnter: modalBeforeEnterFactory(HomePage)
  },
  {
    path: 'reset/:token',
    name: 'PasswordResetPage',
    component: PasswordResetPage
  },
  { path: '*', redirect: '/' }
    ],
  },
];
